<template>
  <div class="third-Bar">
    <router-link
      :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
      v-for="(item, index) in list"
      :key="item.id"
      class="card"
      :style="`grid-area: card-${index + 1}`"
    >
      <div class="image-block">
        <ImageContainer
          :src="item.image.medium"
          :alt="item.title"
          :thumb="item.image.thumbnail"
          class="image"
        />
        <h2
          class="category category-rotate"
          :ref="categoryWrap(index, item.sub_category.name)"
        >
          <span
            v-for="(word, index) in categoryWords[index]"
            :key="index"
            class="rotate"
            :style="`transform:rotate(${index * 7}deg)`"
            >{{ word }}</span
          >
        </h2>
      </div>
      <div class="about">
        <h1 class="text">
          {{ item.title }}
        </h1>
        <h2 class="time">
          {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
        </h2>
      </div>
    </router-link>
  </div>
</template>
<script>
import { ref } from "vue";
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  name: "ThirdBar",
  components: {
    ImageContainer
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    const categoryWords = ref([]);
    let b = 0;
    const categoryWrap = (index, name) => {
      categoryWords.value.push([]);
      if (b === 0) {
        for (let i = 0; i < name.length; i++) {
          categoryWords.value[index].push(name[i]);
        }
        if (index === 6) {
          b++;
        }
      }
    };
    return {
      categoryWrap,
      categoryWords,
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.third-Bar {
  margin: 2rem 0;
  display: grid;
  width: 90%;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: repeat(2, auto);
  grid-template-areas:
    "card-1 card-1 card-1 card-2 card-2 card-2 card-3 card-3 card-3 card-4 card-4 card-4"
    "card-5 card-5 card-5 card-5 card-6 card-6 card-6 card-6 card-7 card-7 card-7 card-7";
  grid-row-gap: 5em;
  position: relative;
  .card {
    position: relative;
    .image-block {
      position: relative;
      width: 100%;
      .image {
        position: relative;
        width: 100%;
        padding-bottom: 66%;
        border-radius: 0px;
        :deep() img {
          border-radius: 0px;
        }
      }
      .category {
        position: absolute;
        top: 0;
        left: 0;
        background-color: var(--secondary-font-color);
        padding: 0.2rem 0.4rem;
        font-family: Open Sans;
        font-style: normal;
        font-weight: 600;
        font-size: 2.5em;
        line-height: 1.4;
        color: var(--category-color);
        text-transform: capitalize;
      }
    }
    .about {
      position: relative;
      margin-top: 0.4rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 0 10%;
      font-size: 2.5em;
      .text {
        --snup: 3;
        display: -webkit-box;
        -webkit-line-clamp: var(--snup);
        -webkit-box-orient: vertical;
        overflow: hidden;
        position: relative;
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        line-height: 1.3;
        color: var(--primary-font-color);
        text-transform: capitalize;
      }
      .time {
        position: relative;
        font-family: Open Sans;
        font-style: normal;
        font-weight: 300;
        line-height: 1;
        color: var(--date-color);
        opacity: 0.6;
        padding-top: 0.6rem;
      }
    }
  }
}
@media screen and (max-width: 2900px) {
  .third-Bar {
    width: 90%;
    .card {
      position: relative;
      .image-block {
        .category {
          font-size: 1.3em;
        }
      }
      .about {
        font-size: 1.3em;
      }
    }
  }
}
@media screen and (max-width: 1920px) {
  .third-Bar {
    width: var(--main-wrapper-width);

    .card {
      position: relative;
      .image-block {
        .category {
          font-size: 1em;
        }
      }
      .about {
        font-size: 1.2em;
        .time {
          font-size: 0.84em;
        }
      }
    }
  }
}

@media screen and (max-width: 978px) {
  .third-Bar {
    margin: 1rem 0;
    grid-template-columns: repeat(7, 1fr);
    grid-template-areas:
      "card-1 card-1 card-1 card-1 card-1 card-1 card-1 "
      "card-2 card-2 card-2 card-4 card-4 card-4 card-4"
      "card-3 card-3 card-3 card-4 card-4 card-4 card-4"
      "card-5 card-5 card-5 card-7 card-7 card-7 card-7"
      "card-6 card-6 card-6 card-7 card-7 card-7 card-7";
    grid-column-gap: 2em;
    grid-row-gap: 2em;
  }
  .card {
    .image-block {
      .image {
        padding-bottom: 66%;
      }
      .category {
        text-transform: uppercase !important;
        font-weight: 600 !important;
        font-size: 0.93em !important;
      }
    }
    .about {
      font-size: 1.15em !important;
      padding: 0 5% !important;
      text-align: center;
      .text {
        --snup: 3 !important;
      }
    }
    &:nth-child(1) {
      padding: 0 3rem;
      .image-block {
        .image {
          border-radius: 129px 0 0 0;
        }
        .category {
          background: none !important;
          top: -1em;
          left: 5em;
          transform: rotate(-65deg) translate(10px, 25px);
        }
        .category-rotate,
        .rotate {
          height: 100px;
          position: absolute;
          width: 10px;
          z-index: 10;
          color: var(--category-color);
          transform-origin: bottom center;
        }
      }
    }
    &:nth-child(2),
    &:nth-child(5) {
      align-self: center;
    }
    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(5),
    &:nth-child(6) {
      margin-top: 0;
      .image-block {
        .image {
          display: none;
        }
        .category {
          padding: 0;
          background: none;
          position: relative;
        }
      }
      .about {
        margin-top: 0.5rem;
        padding: 0 !important;
        text-align: start;
        .text {
          --snup: 4 !important;
        }
      }
    }
  }
}
@media screen and (max-width: 475px) {
  .third-Bar {
    margin: 0.5rem 0;
    width: 100% !important;
    grid-template-columns: repeat(2, 1fr);
    grid-template-areas:
      "card-1 card-1"
      "card-2 card-2"
      "card-3 card-3"
      "card-4 card-4"
      "card-5 card-5"
      "card-6 card-6"
      "card-7 card-7";
    grid-column-gap: 4em;
    grid-row-gap: 1.5em;
    justify-content: space-between;
    .card {
      margin: 0 10px;
      // width: 100%;
      padding: 0;
      .image-block {
        .image {
          display: block;
        }
        .category {
          padding: 0.25rem !important;
          position: absolute;
          background-color: var(--secondary-font-color);
          font-size: 0.72em !important;
        }
      }
      .about {
        text-align: start;
        padding: 0 0.5rem !important;
        margin-top: 0;
        font-size: 0.9em !important;
        .text {
          --snup: 3 !important;
        }
        .time {
          font-size: 0.88em;
        }
      }
      &:nth-child(1) {
        .about {
          text-align: center;
        }
      }
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5),
      &:nth-child(6) {
        display: flex;
        .about {
          width: 100%;
        }
      }
      &:nth-child(3),
      &:nth-child(5) {
        flex-direction: row-reverse;
        .about {
          text-align: end;
        }
      }
      &:nth-child(7) {
        overflow: hidden;
        .image-block {
          .image {
            border-radius: 0 129px 0 0;
          }
          .category {
            background: none;
            transform: rotate(35deg) translate(-25px, 20px);
            top: -1.5em;
            left: inherit;
            right: 6em;
          }
          .category-rotate,
          .rotate {
            height: 100px;
            position: absolute;
            width: 10px;
            z-index: 10;
            color: var(--category-color);
            transform-origin: bottom center;
          }
        }
        .about {
          text-align: center;
        }
      }
    }
  }
}
</style>
